// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","content":"content-iQ-qj","title":"title-3QXgQ","text":"text-3EKAz","linked":"linked-e0u5q"};